import { RefereeDutiesDetailListTable } from './components/referee-duties-list-table';
import { RefereeLicensesListTable } from './components/referee-licenses-list-table';
import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { RefereeBasicInfo } from './components/referee-basic-info';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useDeleteRefereeMutation } from '../mutation';
import { Button } from '~/components/Button/Button';
import { insertOnCondition } from '~/utils/array';
import { useParams } from '~/hooks/useParams';
import { useDialog } from '~/hooks/useDialog';
import { useRefereeQuery } from '../queries';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { toast } from 'react-toastify';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { data, isLoading } = useRefereeQuery(id);
  const { can } = useAuthentication();

  const deleteMutation = useDeleteRefereeMutation();
  const navigate = useNavigate();
  const dialog = useDialog();

  async function handleDelete() {
    await toast.promise(deleteMutation.mutateAsync(id), {
      success: 'Domaren har tagits bort',
      pending: 'Tar bort domare...',
    });

    navigate('..');
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={`${data.person.first_name} ${data.person.last_name}`} />

        <Button.Group neutral>
          {can('list-referee-license') && (
            <Button type="button" onClick={() => navigate('licenses')}>
              Licenser
            </Button>
          )}

          <PageLayout.Context
            items={[
              ...insertOnCondition(<ContextMenu.Item label="Redigera" to="edit" key="edit" />, can('edit-referee')),
              ...insertOnCondition(
                <ContextMenu.Item label="Ta bort" onClick={dialog.open} key="delete" danger />,
                can('delete-referee')
              ),
            ]}
          />
        </Button.Group>
      </PageLayout.Header>

      <PageLayout.Section>
        <RefereeBasicInfo referee={data} />
      </PageLayout.Section>

      <PageLayout.Section>
        <RefereeDutiesDetailListTable />
      </PageLayout.Section>

      <PageLayout.Section>
        <RefereeLicensesListTable data={data.judge_licenses} isLoading={isLoading} />
      </PageLayout.Section>

      <ConfirmDialog {...dialog} isLoading={deleteMutation.isPending} onConfirm={handleDelete} />
    </Fragment>
  );
}
